"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicQuantityFormatter = void 0;
const NumberService_1 = require("./NumberService");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
/**
 * concrete implementation of the QuantityFormatter interface
 */
class BasicQuantityFormatter {
    constructor(options) {
        this.unitSystem = options.unitSystem;
        this.locale = options.languageTag;
        this.unit = options.unit;
        this.roundType = options.roundType;
        this.precision = options.precision;
        this.significantPrecision = options.significantPrecision;
    }
    formatValue(quantity, hasGroupingSeparators = false, fallback = '') {
        return quantity ? this.toQuantityValueString(quantity, hasGroupingSeparators) || fallback : fallback;
    }
    toQuantityValue(quantity) {
        return quantity === null || quantity === void 0 ? void 0 : quantity.getValue(this.unit);
    }
    toQuantityValueString(quantity, hasGroupingSeparators) {
        const quantityValue = quantity.getValue(this.unit);
        return quantityValue || quantityValue === 0
            ? this.toLocalizedString(quantityValue, hasGroupingSeparators)
            : undefined;
    }
    toLocalizedString(value, hasGroupingSeparators) {
        const localizedString = NumberService_1.numberService.toLocalizedString(value, this.locale, hasGroupingSeparators, this.roundType, this.precision, this.significantPrecision);
        if (localizedString == null) {
            throw new Error(`BasicQuantityFormatter.toLocalizedString(): results in undefined`);
        }
        return localizedString;
    }
    toQuantityUnitString() {
        return echain_shared_quantities_1.Q.getUnitText(this.unit);
    }
}
exports.BasicQuantityFormatter = BasicQuantityFormatter;
//# sourceMappingURL=BasicQuantityFormatter.js.map